import React from "react";
import { PureComponent } from "react";
import { View } from "react-native";
import { ODictLink } from "./olonkho-fw";
import RenderHtml from "react-native-render-html";

export default class CompareItem extends PureComponent {

    constructor(props) {
        super(props);
    }
    
    render() {
        return (
            <View style={{ marginBottom: 10 }}>
                <View style={ { 
                    alignItems: 'center',
                    borderLeftWidth: 0.5,
                    borderRightWidth: 0.5,
                    borderTopWidth: 1
                } }>
                    <ODictLink lines={ this.props.item.lines } navigation={ this.props.navigation }/>
                </View>
                <RenderHtml 
                    source={ { 
                        html: "<table><tr><td>" + this.props.item.text + "</td><td>" + this.props.item.translate + "</td></tr></table>"
                    } }
                    contentWidth={ this.props.width }
                    tagsStyles={{ 
                        td: {
                            borderLeftWidth: 0.5,
                            borderRightWidth: 0.5,
                            borderTopWidth: 1,
                            borderBottomWidth: 1,
                            fontSize: 10,
                        },
                        b: {
                            fontWeight: 'bold'
                        } 
                    }}
                />
            </View>
        );
    }
}